import React, { useEffect } from "react";
import NProgress from "nprogress";

import "nprogress/nprogress.css";
import "./nprogress.css";

const RouteLoader: React.FC = () => {
  useEffect(() => {
    NProgress.configure({ showSpinner: false }).start();

    return () => {
      NProgress.done();
    };
  }, []);

  return null;
};

export default RouteLoader;
